import axios from 'axios'

export default {
    namespaced: true,
    state: {
        loadingAgents: false,
        loadingSuitableAgents: false,
        agents: [],
        suitableAgents: [],
        subroles: [],
        suitableAgentsByStates: []
    },

    getters: {
        agents: (state) => state.agents,
        suitableAgentsByStates: (state) => state.suitableAgentsByStates,
        suitableAgents: (state) => state.suitableAgents,
        loadingSuitableAgents: (state) => state.loadingSuitableAgents,
        loadingAgents: (state) => state.loadingAgents,
        subroles: (state) => state.subroles
    },

    mutations: {
        SET_AGENTS(state, agents) {
            state.agents = agents;
        },
        SET_SUITABLE_AGENTS_BY_STATES(state, agents) {
            state.suitableAgentsByStates = agents;
        },
        SET_LOADING_AGENTS(state, loadingAgents) {
            state.loadingAgents = loadingAgents;
        },

        SET_SUITABLE_AGENTS(state, suitableAgents) {
            state.suitableAgents = suitableAgents;
        },

        SET_LOADING_SUITABLE_AGENTS(state, loadingSuitableAgents) {
            state.loadingSuitableAgents = loadingSuitableAgents;
        },

        SET_SUBROLES(state, roles) {
            state.subroles = roles;
        }
    },

    actions: {
        loadAgents({ commit }) {
            return new Promise((resolve => {
                commit("SET_LOADING_AGENTS", true);

                axios.get("/agents")
                    .then(res => {
                        commit("SET_AGENTS", res.data.agents);
                        commit("SET_LOADING_AGENTS", false);
                        resolve(res.data.agents);
                    })
                    .catch(err => {
                        console.error(err);
                        commit("SET_LOADING_AGENTS", false);
                    });
            }));
        },

        loadAgentWithSuitableState({ commit }, state_id) {
            commit('SET_LOADING_SUITABLE_AGENTS', true);
            axios.post("/agents/suitable", {
                state_id
            }).then(res => {
                commit('SET_SUITABLE_AGENTS', res.data.agents);
                commit('SET_LOADING_SUITABLE_AGENTS', false);
            }).catch(err => {
                console.log(err)
                commit('SET_LOADING_SUITABLE_AGENTS', false);
            })
        },
        loadSubroles({ commit }) {
            axios.get("/agents/subroles").then((res) => {
                commit("SET_SUBROLES", res.data.subroles);
            }).catch((err) => console.log(err));
        },

        loadSuitableAgentsByStates({ commit }, leads) {
            axios.post("/agents/suitable/states", leads).then(res => {
            commit("SET_SUITABLE_AGENTS_BY_STATES", res.data.agents);
            }).catch(err => {
                console.log(err);
            });
        }
    },

};
